import { RouteConfig, Route, NavigationGuardNext } from "vue-router";
const tabOneWelcome = () => import("./quote/views/tab-one.vue");
const tabTwoAP24Hs = () => import("./quote/views/tab-two.vue");
const tabThreeAP24Hs = () => import("./quote/views/tab-three.vue");
const tabFourPlansAP24Hs = () => import("./quote/views/tab-four.vue");
const policyOwner = () => import("../shared/policyOwner.vue");
const personToCover = () => import("../shared/personToCover.vue");
const optionals = () => import("../shared/Optionals.vue");
const APSummary = () => import("../shared/ApSummary.vue");
const FinalPayment = () => import("../shared/finalPayment.vue");

const pageTitle = 'Cotizá tu seguro de Accidentes personales AP24HS | Sancor Seguros';
const contentMetaData = 'Cotizá tu seguro de Accidentes personales AP24HS de manera rápida y sencilla.Compará precios y encontrá la cobertura que mejor se adapte a tus necesidades y presupuesto.'

const routes: Array<RouteConfig> = [    
    {
        path: "/ap-24-hs/DatosContratante",
        name: "ap-24-hs-tab-two",
        component: tabTwoAP24Hs,
        meta: {
            title: () => 'Datos de la Persona que contrata',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },

    {
        path: "/ap-24-hs/DatosVigencia",
        name: "ap-24-hs-tab-three",
        component: tabThreeAP24Hs,
        meta: {
            title: () => 'Datos de que quieres contratar',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },

    {
        path: "/ap-24-hs/Planes",
        name: "ap-24-hs-tab-four",
        component: tabFourPlansAP24Hs,
        meta: {
            title: () => 'Elegí el Plan',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },

    {
        path: "/ap-24-hs/Contratante",
        name: "ap-24-hs-tab-policyOwner",
        component: policyOwner,
        meta: {
            title: () => 'Datos de la Persona que Contrata',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },

    {
        path: "/ap-24-hs/datosAsegurado",
        name: "ap-24-hs-tab-personToCover",
        component: personToCover,
        meta: {
            title: () => 'Datos de la Persona a Cubrir',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },

    {
        path: "/ap-24-hs/opcionales",
        name: "ap-24-hs-tab-optionals",
        component: optionals,
        meta: {
            title: () => 'Clausulas opcionales',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },

    {
        path: "/ap-24-hs/resumen",
        name: "ap-24-hs-APSummary",
        component: APSummary,
        meta: {
            title: () => 'Resumen',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },
    {
        path: "/ap-24-hs/finContrato",
        name: "ap-24-hs-APFinalPayment",
        component: FinalPayment,
        meta: {
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            const { ParamId, ExternalIdentifier, ChannelId } = to.query as {
                ParamId?: string;
                ExternalIdentifier?: string;
                ChannelId?: string;
            };

            // Si llega alguno de los tres parámetros, se guarda en sessionStorage
            if (ParamId || ExternalIdentifier || ChannelId) {
                if (ParamId) {
                    sessionStorage.setItem("ParamId", ParamId);
                }
                if (ExternalIdentifier) {
                    sessionStorage.setItem("PricingId", ExternalIdentifier);
                }
                if (ChannelId) {
                    sessionStorage.setItem("ChannelId", ChannelId);
                }

                sessionStorage.setItem("ExitOrContinueModal", "false");

                const timeStart = new Date();
                sessionStorage.setItem("TimeStartPaymentComplete", JSON.stringify(timeStart));

                next({ path: to.path, query: {} });
            } else {
                // Si no hay query params, seguimos normalmente
                next();
            }
        }
    },
    // Ruta comodín debe ir al final siempre
    {
        path: "/ap-24-hs/:subpath*",
        name: "ap-24-hs-tab-One",
        component: tabOneWelcome,
        meta: {
            title: () => 'Datos personales',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]
        },
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            const { utm_source } = to.query as { utm_source?: string };

            const existente = sessionStorage.getItem("Referente");
            if (!existente) {
                if (utm_source) {
                    sessionStorage.setItem("Referente", utm_source);
                }
                else {
                    if (document.referrer != '') {
                        sessionStorage.setItem("Referente", document.referrer);
                    }
                    else {
                        sessionStorage.setItem("Referente", null);
                    }
                }
            }

            const { utm_medium } = to.query as { utm_medium?: string };

            const existente_medium = sessionStorage.getItem("Medium");
            if (!existente_medium) {
                if (utm_medium) {
                    sessionStorage.setItem("Medium", utm_medium);
                }
                else {
                    sessionStorage.setItem("Medium", 'organic');
                }
            }

            if (Object.keys(to.query).length > 0) {
                next({ path: to.path, query: {} });
            } else {
                next();
            }
        }
    },
];

export default routes;
